import {
  ADD_NEW_TOC_ENTRIES,
  ADD_SECTION,
  CLEAR_REMOVED,
  CLOSE_TOC_NEED_REFRESH,
  CLOSE_TOC_SAVE_ALERT,
  DELETE,
  FROM_SIGNALR,
  type IMosaicTocExpanded,
  type ITocAction,
  MOVE_ITEM,
  REASSIGN_TOC_NUMBERS,
  REFRESH,
  SAVE_FAIL,
  SAVE_SUCCESS,
  SAVING_TOC_ITEM_VIA_TLF,
  SET_TOC_REQUEST_STATUS,
  SET_TYPE_FILTER,
  SHOW_TOC_NEED_REFRESH,
  SHOW_TOC_SAVE_ALERT,
  SORT_TOC,
  UPDATE_AFTER_PATCH,
  UPDATE_COMMENTS_FILTER,
  UPDATE_ENTRY,
  UPDATE_LAST_MAJOR_VERSION_SAVED_AT,
  UPDATE_SEARCH_TEXT,
  UPDATE_SECTION,
  UPDATE_TRAFFIC_LIGHTS_FILTER,
  UPDATE_VIEW_TIFO,
} from "./interface";
import {
  toc_addNewTocEntries,
  toc_addSection,
  toc_clearRemoved,
  toc_closeTocNeedRefresh,
  toc_closeTocSaveAlert,
  toc_delete,
  toc_fromSignalR,
  toc_moveItem,
  toc_reassignTocNumbers,
  toc_refresh,
  toc_saveFail,
  toc_saveSuccess,
  toc_savingTocItemViaTlf,
  toc_setTocRequestStatus,
  toc_setTypeFilter,
  toc_showTocNeedRefresh,
  toc_showTocSaveAlert,
  toc_sortToc,
  toc_updateAfterPatch,
  toc_updateCommentsFilter,
  toc_updateEntry,
  toc_updateLastMajorVersionSavedAt,
  toc_updateSearchText,
  toc_updateSection,
  toc_updateTrafficLightsFilter,
  toc_updateViewTiFo,
} from "./toc_functions";

/**
 * Reducer for ToC context state transitions.
 *
 * @param state - The current `IMosaicTocExpanded` state.
 * @param action - The `ITocAction` describing the update to perform.
 * @returns The updated `IMosaicTocExpanded` after applying the action.
 */
export const tocContextReducer = (
  state: IMosaicTocExpanded,
  action: ITocAction,
): IMosaicTocExpanded => {
  switch (action.operation) {
    case ADD_NEW_TOC_ENTRIES:
      return toc_addNewTocEntries(state, action);

    case ADD_SECTION:
      return toc_addSection(state, action);

    case CLEAR_REMOVED:
      return toc_clearRemoved(state);

    case CLOSE_TOC_NEED_REFRESH:
      return toc_closeTocNeedRefresh(state);

    case CLOSE_TOC_SAVE_ALERT:
      return toc_closeTocSaveAlert(state);

    case DELETE:
      return toc_delete(state, action);

    case FROM_SIGNALR:
      return toc_fromSignalR(state, action);

    case MOVE_ITEM:
      return toc_moveItem(state, action);

    case REASSIGN_TOC_NUMBERS:
      return toc_reassignTocNumbers(state);

    case REFRESH:
      return toc_refresh(state, action);

    case SAVE_FAIL:
      return toc_saveFail(state);

    case SAVE_SUCCESS:
      return toc_saveSuccess(state, action);

    case SAVING_TOC_ITEM_VIA_TLF:
      return toc_savingTocItemViaTlf(state);

    case SET_TOC_REQUEST_STATUS:
      return toc_setTocRequestStatus(state, action);

    case SET_TYPE_FILTER:
      return toc_setTypeFilter(state, action);

    case SHOW_TOC_NEED_REFRESH:
      return toc_showTocNeedRefresh(state);

    case SHOW_TOC_SAVE_ALERT:
      return toc_showTocSaveAlert(state, action);

    case SORT_TOC:
      return toc_sortToc(state);

    case UPDATE_AFTER_PATCH:
      return toc_updateAfterPatch(state);

    case UPDATE_COMMENTS_FILTER:
      return toc_updateCommentsFilter(state, action);

    case UPDATE_ENTRY:
      return toc_updateEntry(state, action);

    case UPDATE_LAST_MAJOR_VERSION_SAVED_AT:
      return toc_updateLastMajorVersionSavedAt(state, action);

    case UPDATE_SEARCH_TEXT:
      return toc_updateSearchText(state, action);

    case UPDATE_SECTION:
      return toc_updateSection(state, action);

    case UPDATE_TRAFFIC_LIGHTS_FILTER:
      return toc_updateTrafficLightsFilter(state, action);

    case UPDATE_VIEW_TIFO:
      return toc_updateViewTiFo(state, action);
  }
};
